module.exports = __webpack_public_path__ + "img/share1.eca0773e.png";